import localForage from "localforage";

class DeviceCacheHelper {
  private readonly eventEditionIdKey = "ee-id";
  private readonly deviceHmacKey = "dh";
  private readonly deviceInstanceIdKey = "dii";

  async cacheEventEditionId(eventEditionId: string) {
    await localForage.setItem(this.eventEditionIdKey, eventEditionId);
  }

  async cacheDeviceInstanceId(deviceInstanceId: string) {
    await localForage.setItem(this.deviceInstanceIdKey, deviceInstanceId);
  }

  async getCachedInstanceId(): Promise<string> {
    try {
      return (await localForage.getItem(this.deviceInstanceIdKey)) as string;
    } catch (e) {
      return "";
    }
  }

  async getCachedEventEditionId() {
    try {
      return await localForage.getItem(this.eventEditionIdKey);
    } catch (e) {
      return "";
    }
  }

  async saveDeviceHmac(part1: string, part2: string) {
    try {
      return await localForage.setItem(this.deviceHmacKey, `${part1}${part2}`);
    } catch (e) {
      return "";
    }
  }

  async getDeviceHmac() {
    return (await localForage.getItem(this.deviceHmacKey)) as string;
  }

  async resetCache() {
    try {
      await localForage.removeItem(this.deviceHmacKey);
      await localForage.removeItem(this.deviceInstanceIdKey);
      await localForage.removeItem(this.eventEditionIdKey);
    } catch (e) {
      console.warn(e);
    }
  }
}

export default new DeviceCacheHelper();
